// import React from 'react';
// import NextImage from '@/features/Image';
// import parse from 'html-react-parser';
// import { parse as parseUrl } from 'url';
// import Link from 'next/link';
// import SurpriseGiftForm from './SurpriseGiftForm';

// type Props = {
//   title: string;
//   description: string;
//   banner: string;
//   banner_web: string;
//   btn_name: string;
//   route: string;
//   is_active: string;
// };

// const SaleBanner = ({
//   data,
// }: {
//   data: { group_shopping: Props; surprize_gift: Props };
// }) => {
//   const { group_shopping, surprize_gift } = data;

//   const groupLinkPath = group_shopping?.route
//     ? parseUrl(group_shopping.route).pathname
//     : '/personal-recommendation/skincare-recommendation';

//   return (
//     <section className="sale-section padding-bottom">
//       <div className="container">
//         <div
//           className="sale-section__wrapper"
//           data-aos="fade-up"
//           data-aos-duration={1000}
//         >
//           <div className="row g-4">
//             {group_shopping && (
//               <div className="col-sm-6">
//                 <div className="sale-card sale-card--community h-100">
//                   <div className="sale-card__inner py-2 py-lg-0 d-flex flex-column align-items-center justify-content-center flex-lg-row gap-3">
//                     <div className="sale-card__image">
//                       <NextImage
//                         width={260}
//                         height={260}
//                         src={
//                           group_shopping?.banner_web ||
//                           '/images/flash-sale/2.png'
//                         }
//                         alt="Community Offer"
//                         className="img-fluid"
//                       />
//                     </div>
//                     <div className="sale-card__content mt-3 mt-md-0">
//                       <h2 className="sale-card__title fw-medium">
//                         {group_shopping?.title}
//                       </h2>
//                       {/* <p className="sale-card__text ">
//                         Saver the goodness nature with our healthy fruits.
//                       </p> */}

//                       {group_shopping?.description &&
//                         parse(group_shopping?.description)}

//                       <Link
//                         href={`${groupLinkPath}`}
//                         className="trk-btn trk-btn--primary  mt-2"
//                       >
//                         {group_shopping?.btn_name}
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {surprize_gift && (
//               <div className="col-sm-6">
//                 <div className="sale-card sale-card--reward h-100">
//                   <div className="sale-card__inner py-2 py-lg-0 d-flex flex-column align-items-center justify-content-center flex-lg-row gap-3">
//                     <div className="sale-card__image">
//                       <NextImage
//                         width={260}
//                         height={260}
//                         src={
//                           surprize_gift?.banner || '/images/flash-sale/31.png'
//                         }
//                         alt="Member Reward"
//                         className="img-fluid"
//                       />
//                     </div>
//                     <div className="sale-card__content mt-3 mt-md-0">
//                       <h2 className="sale-card__title fw-medium">
//                         {surprize_gift?.title}
//                       </h2>
//                       {/* <p
//                         className="sale-card__text"
//                         style={{ maxWidth: '253px' }}
//                       >
//                         Dive into a world of exquisite flavors with our seafood.
//                       </p> */}

//                       {surprize_gift?.description &&
//                         parse(surprize_gift?.description)}

//                       <SurpriseGiftForm btn_name={surprize_gift?.btn_name} />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SaleBanner;

// src/features/home/SaleBanner/components/SaleBanner.tsx

// NO 'use client'. This is now a Server Component.
'use client';
import Link from 'next/link';
import Image from 'next/image'; // Use the original next/image
import SurpriseGiftForm from './SurpriseGiftForm'; // Import the client component
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { SaleBannerSkeleton } from './SaleBannerSkeleton';
import { BannerSkeleton } from '../../banner/components/BannerSkeleton';
import NextImage from '@/features/Image';

// Define the types for better code quality
type BannerProps = {
  title: string;
  description: string;
  banner: string;
  banner_web: string;
  btn_name: string;
  route: string;
};

// This component is now ASYNC
const SaleBanner = () => {
  // ✅ DATA IS FETCHED HERE, INSIDE THE COMPONENT
  // We fetch the data needed for both banners.
  // const home_things = await fetcher('/api/v2/home-things?for=desktop');
  const { data: homeThings, isLoading } = useFetcherCSR(
    `/api/v2/home-things?for=desktop`
  );

  if (isLoading) return <BannerSkeleton />;
  const data = homeThings?.homepage_settings;
  const group_shopping = data?.group_shopping as BannerProps | undefined;
  const surprize_gift = data?.surprize_gift as BannerProps | undefined;
  const showGroupShopping =
    homeThings?.homepage_settings?.features?.group_shopping;
  const showSurprizeGift =
    homeThings?.homepage_settings?.features?.surprize_gift;
  // Function to safely parse a URL path, avoiding the heavy 'url' module
  const getPathname = (
    route: string | undefined,
    defaultPath: string
  ): string => {
    if (!route) return defaultPath;
    try {
      // Handles full URLs
      return new URL(route).pathname;
    } catch (e) {
      // Handles relative paths like '/products'
      if (route.startsWith('/')) return route;
    }
    return defaultPath;
  };

  const groupLinkPath = getPathname(group_shopping?.route, '/group-shopping');

  // If there's no data for either banner, don't render the section
  if (!group_shopping && !surprize_gift) {
    return null;
  }
  if (!showGroupShopping && !showSurprizeGift) {
    return null;
  }

  return (
    <section className="sale-section padding-bottom">
      <div className="container">
        {/* ✅ REMOVED data-aos wrapper. The design remains identical. */}
        <div className="sale-section__wrapper">
          <div className="row g-4">
            {group_shopping && showGroupShopping && (
              <div className="col-sm-6">
                <div className="sale-card sale-card--community h-100">
                  <div className="sale-card__inner py-2 py-lg-0 d-flex flex-column align-items-center justify-content-center flex-lg-row gap-3">
                    <div className="sale-card__image">
                      <NextImage
                        width={260}
                        height={260}
                        src={group_shopping.banner_web}
                        alt="Community Offer"
                        className="img-fluid"
                        sizes="(max-width: 576px) 90vw, (max-width: 768px) 50vw, 260px"
                      />
                    </div>
                    <div className="sale-card__content mt-3 mt-md-0">
                      <h2 className="sale-card__title fw-medium">
                        {group_shopping.title}
                      </h2>
                      {/* ✅ Replaced heavy parser with safe, standard React feature */}
                      {group_shopping.description && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: group_shopping.description,
                          }}
                        />
                      )}
                      <Link
                        href={groupLinkPath}
                        className="trk-btn trk-btn--primary mt-2"
                      >
                        {group_shopping.btn_name}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {showSurprizeGift && surprize_gift && (
              <div className="col-sm-6">
                <div className="sale-card sale-card--reward h-100">
                  <div className="sale-card__inner py-2 py-lg-0 d-flex flex-column align-items-center justify-content-center flex-lg-row gap-3">
                    <div className="sale-card__image">
                      <NextImage
                        width={260}
                        height={260}
                        src={surprize_gift.banner}
                        alt="Member Reward"
                        className="img-fluid"
                        sizes="(max-width: 576px) 90vw, (max-width: 768px) 50vw, 260px"
                      />
                    </div>
                    <div className="sale-card__content mt-3 mt-md-0">
                      <h2 className="sale-card__title fw-medium">
                        {surprize_gift.title}
                      </h2>
                      {surprize_gift.description && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: surprize_gift.description,
                          }}
                        />
                      )}
                      {/* We render the client component here */}
                      <SurpriseGiftForm btn_name={surprize_gift.btn_name} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SaleBanner;
